import { createSelector } from 'reselect'
import { OptimizelyFeatureFlags } from 'constants/featureFlags'
import { getFunnelFeatures } from 'checkout/selectors/funnel'
import getCheckoutItemViewsWithPropertyRateUpgrade from './getCheckoutItemViewsWithPropertyRateUpgrade'

/**
 * Whether checkout shows a property-rate package upgrade tile. It counts as a stay upgrade to redeem,
 * so it can bring up the loyalty section when no other benefit does.
 */
const getCanShowCheckoutPropertyRateUpgradeTile = createSelector(
  (state: App.State) => getFunnelFeatures(state).roomUpgrade,
  (state: App.State) => !!state.optimizely.optimizelyFeatureFlags[OptimizelyFeatureFlags.loyaltySppPackageUpgrades],
  (state: App.State) => getCheckoutItemViewsWithPropertyRateUpgrade(state),
  (showUpgradeBenefit, isPackageUpgradeEnabled, itemViews): boolean =>
    showUpgradeBenefit && isPackageUpgradeEnabled && itemViews.length > 0,
)

export default getCanShowCheckoutPropertyRateUpgradeTile
